import { useTranslation } from 'react-i18next';

export const FobiddenPage = () => {
  const { t } = useTranslation();

  return <div>{t('com.label.Fobidden 403 권한이 없습니다.', 'Fobidden 403 권한이 없습니다.')}</div>;
};

export default FobiddenPage;
